module.exports = "<svg viewBox=\"0 0 30 21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M27.188 21H2.813C1.262 21 0 19.715 0 18.136V2.864C0 1.284 1.262 0 2.813 0h24.375C28.738 0 30 1.285 30 2.864v15.272C30 19.716 28.738 21 27.187 21zM2.813 19.09h24.375c.516 0 .937-.428.937-.954V3.166L15.61 14.088a.93.93 0 0 1-.61.23.93.93 0 0 1-.61-.23L1.875 3.166v14.97c0 .526.42.955.938.955zm23.87-17.18H3.317L15 12.106 26.684 1.91z\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/campaigns/email.svg
// module id = Bb1a
// module chunks = 89